export default "__VITE_ASSET__BI2UYqb6__"